module.exports = __webpack_public_path__ + "static/media/external-link-alt-hover.74ba81d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/external-link-alt-hover.svg
// module id = 536
// module chunks = 0